module.exports = __webpack_public_path__ + "img/veyosis-logo.d29e2b3d.svg";